import { render, staticRenderFns } from "./WalletConnectButton.vue?vue&type=template&id=c3dd92fc&"
import script from "./WalletConnectButton.vue?vue&type=script&lang=ts&"
export * from "./WalletConnectButton.vue?vue&type=script&lang=ts&"
import style0 from "./WalletConnectButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/home/runner/work/did-homepage/did-homepage/src/components/Button.vue').default})
